import PropTypes from "prop-types";
import ParticleTwo from "../../particles/ParticleTwo";
import { Link } from "react-router-dom";
const BreadcrumbPipsTerminal = () => {
  return (
    <div
      className="ht__bradcaump__area__platform"
      style={{
        background: `rgba(0, 0, 0, 0) url(${
          process.env.PUBLIC_URL + "/images/about/bull_right_side.jpg"
        }) repeat scroll center center/105% 100%`,
      }}
    >
      <div className="ht__bradcaump__container__platform">
        <div className="container">
          <div className="row">
            <div className="col-lg-9">
              <h1>The Pips Terminal</h1>
              <p>
                Experience next-generation trading with a terminal designed for
                speed, precision, and total control, all within an elegant,
                data-driven interface.
              </p>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/company/contact"}
              >
                Launch The Pips Terminal
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* <ParticleTwo /> */}
    </div>
  );
};

BreadcrumbPipsTerminal.propTypes = {
  title: PropTypes.string,
};

export default BreadcrumbPipsTerminal;
